
/**
 * @file
 * Behaviors for the Carousel.
 */

!((Drupal, $) => {
    'use strict';

    /**
     * Setup and attach the Carousel behaviors.
     *
     * @type {Drupal~behavior}
     */
    Drupal.behaviors.carousel = {
        attach: function () {
            $(document).ready(
                function () {
                    // let deshtml = $(".operationDescription p").html();
                    // let textdest = "";
                    // if (window.location.href.split('/').includes('vi')) {
                    //     textdest = deshtml + "</br>" + "<span class='note_description'>Lưu ý: Sau trải nghiệm tại Sandbox, khi đối tác thực hiện tích hợp trên môi trường phát triển của BIDV, tuỳ từng API sẽ cần bổ sung phương thức ký số theo chuẩn JWS( Json Web Signatures) và mã hóa theo chuẩn JWE(Json Web Encryption).</span>";
                    // } else {
                    //     textdest = deshtml + "</br>" + "<span class='note_description'>Note: After experience on sandbox, when partners perform integration on BIDV's development environment (UAT), depending on each API, digital signature according to JWS standard (Json Web Signatures) and encryption according to JWE standards (Json Web Encryption) need to be added.</span>";
                    // }
                    // $(".operationDescription p").html(textdest);
                    // $("span.note_description").attr("style", "font-style: italic;color:red");

                    if (window.location.href.split('/').includes('vi')) {

                        // Application Subscribtion Page No Product View
                        $("td.noSubsFound a").empty().text("Nhấn vào đây để xem các sản phẩm hiện có");

                        // Login Forms
                        $(".user-login-form .apic-user-form-subheader").empty().text("Đăng nhập");

                        $('.user-register-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Create account using Facebook User Registry"]').empty();
                        $('.user-pass .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Đăng nhập với Facebook User Registry"]').empty();

                        //$('.user-register-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Create account using Facebook User Registry"]').empty().text("Đăng ký với tài khoản Facebook");
                        //$('.user-pass .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Đăng nhập với Facebook User Registry"]').empty().text("Quên mật khẩu qua tài khoản Facebook");
                        // $(".user-login-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button span").empty().text("Đăng nhập qua Facebook");  
                        // $(".user-register-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button span").empty().text("Đăng ký với Facebook");  
                        // $(".user-pass .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button span").empty().text("Quên mật khẩu qua Facebook");  
                    } else {
                        // Application Subscribtion Page No Product View
                        $("td.noSubsFound a").empty().text("Click here to see available products");

                        // Login Forms
                        $(".user-login-form .apic-user-form-subheader").empty().text("Sign in");


                        $('.user-register-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Create account using Facebook User Registry"]').empty();
                        $('.user-pass .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Sign in using Facebook User Registry"]').empty();
                        //$('.user-register-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Create account using Facebook User Registry"]').empty().text("Sign up with Facebook");
                        //$('.user-pass .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Sign in using Facebook User Registry"]').empty().text("Forgot Password with Facebook");
                        // $(".user-login-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button span").empty().text("Sign in with Facebook");  
                        // $(".user-register-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button span").empty().text("Sign up with Facebook");  
                        // $(".user-pass .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button span").empty().text("Forgot Password with Facebook");  
                    }

                    //$('.user-login-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Đăng nhập với Facebook User Registry"]').empty().text("Đăng nhập qua tài khoản Facebook");
                    //$('.user-login-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Sign in using Facebook User Registry"]').empty().text("Sign in with Facebook");
                    $('.user-login-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Đăng nhập với Facebook User Registry"]').empty();
                    $('.user-login-form .apic-user-form-inner-wrapper.apic-user-form-registries a.registry-button[title="Sign in using Facebook User Registry"]').empty();

                    $(".apicAttachments table td span.file a").each(function (value, key) {
                        var href = $(key).attr("href");
                        var check = href.indexOf("system/files/");
                        // var newHref = "";
                        // if (window.location.href.indexOf("/vi/") > -1) {
                        //   newHref = window.location.href.split("/vi/")[0] + href.substr(check);
                        // } else if (window.location.href.indexOf("/en/") > -1) {
                        //   newHref = window.location.href.split("/en/")[0] + href.substr(check);
                        // }
                        // else {
                        //   newHref = window.location.href.split("/product")[0] + href.substr(check);
                        // }
                        var newHref = window.location.origin + drupalSettings.path.baseUrl + href.substr(check);
                        console.log(newHref);
                        if (check > -1) {
                            $(key).attr("href", newHref);
                            $(key).attr("target", "_blank");
                        }
                    });

                }
            );
        }
    };
})(Drupal, jQuery);